import React, { createContext, useContext, useState, useEffect } from "react";
const {
  THEME_STORAGE_KEY,
  THEME_ATTRIBUTE,
  DARK_THEME_VALUE,
  LIGHT_THEME_VALUE,
  PREFERS_DARK_MEDIA_QUERY,
  shouldUseDarkTheme,
} = require("../utils/themeBootstrap");

const ThemeContext = createContext({ isDarkMode: false, toggleTheme: () => {} });

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    const prefersDark = window.matchMedia(PREFERS_DARK_MEDIA_QUERY).matches;
    const shouldBeDark = shouldUseDarkTheme(saved, prefersDark);

    if (shouldBeDark) {
      setIsDarkMode(true);
      document.documentElement.setAttribute(THEME_ATTRIBUTE, DARK_THEME_VALUE);
    }
  }, []);

  const toggleTheme = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    const selectedTheme = newMode ? DARK_THEME_VALUE : LIGHT_THEME_VALUE;
    document.documentElement.setAttribute(THEME_ATTRIBUTE, selectedTheme);
    localStorage.setItem(THEME_STORAGE_KEY, selectedTheme);
  };

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
